import { classNames, isStatusPreGame } from '@library/utils';
import type { Status } from '@library/types/projection';

export interface StatTypeLabelProps {
  statType: string;
  status?: Status;
}

export const StatTypeLabel = ({
  statType,
  status = undefined
}: StatTypeLabelProps) => (
  <td
    className={classNames(
      'text-soClean-100 py-4 text-xs font-medium',
      !isStatusPreGame(status) ? 'opacity-50' : ''
    )}
    key={statType}
  >
    <span>{statType}</span>
  </td>
);
